import { frontendURL } from '../../../helper/URLHelper';
import VisitasIndex from '../visitas/pages/VisitasIndex.vue';

export default {
  path: frontendURL('accounts/:accountId/visitas-realizadas'),
  component: VisitasIndex,
};
